import * as THREE from "three";
import React from "react";

function Scene({texture}) {
    return (
        <mesh>
            <sphereGeometry args={[500, 60, 40]} scale-x={-1}/>
            <meshBasicMaterial map={texture} side={THREE.BackSide}/>
        </mesh>
    )
}

export default Scene;